import {MOON_250} from '@wandb/weave/common/css/globals.styles';
import React from 'react';

import {useViewer} from '../../../state/viewer/hooks';
import {SemanticLoader as Loader} from '../../utility/InstrumentedLoader';
import {sortTemplateVariablesByConfig} from '../DefaultResourceConfig/defaultResourceConfigUtil';
import {useRunInfoMapFromQueues} from '../hooks';
import {QueueItemsTable} from '../Queues/QueueItemsTable';
import {
  enhanceRunQueueItems,
  isQueuePrioritizationEnabled,
  Queue,
  RUN_QUEUE_ITEM_DISPLAY_THRESHOLD,
} from '../Queues/queueUtil';
import * as S from './TabRuns.styles';

type TabRunsProps = {
  queue: Queue;
  refetchQueue: () => void;
};

export const TabRuns = ({queue, refetchQueue}: TabRunsProps) => {
  const {entityName, items} = queue;
  const viewer = useViewer();
  const isTeam = entityName !== viewer?.username;
  const entity = isTeam ? `members of the ${entityName} team` : 'you';

  const runInfoMap = useRunInfoMapFromQueues(queue);

  if (runInfoMap == null) {
    return <Loader active inline="centered" name="tab-runs-loader" />;
  }

  const enhancedItems = enhanceRunQueueItems(items, queue, runInfoMap);

  const sortedTemplateVariables = sortTemplateVariablesByConfig(
    JSON.stringify(queue.defaultResourceConfig?.config ?? {}),
    queue.variables ?? []
  );
  return (
    <>
      {enhancedItems.length === 0 ? (
        <>
          <S.EmptyQueueTitle>This queue is empty.</S.EmptyQueueTitle>
          <S.EmptyQueueMessage>
            Runs will appear here when {entity}
            <br />
            start launching runs from a project's job tab.
          </S.EmptyQueueMessage>
        </>
      ) : (
        <>
          <S.AutomaticClearMessage>
            {`Completed and failed runs automatically clear after ${RUN_QUEUE_ITEM_DISPLAY_THRESHOLD} days.`}
          </S.AutomaticClearMessage>
          <QueueItemsTable
            border={`1px solid ${MOON_250}`}
            entityName={entityName}
            items={enhancedItems}
            queueId={queue.id}
            queueName={queue.name}
            templateVariables={sortedTemplateVariables}
            refetchQueue={refetchQueue}
            showPriority={isQueuePrioritizationEnabled(queue)}
          />
        </>
      )}
    </>
  );
};
